import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Drawer, Button, Space, Modal, Input, notification } from "antd";
import Pagination from "@mui/material/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faEye, faBan } from "@fortawesome/free-solid-svg-icons";
import TobNavBar from "../../DashBaord/Top_navbar";
import ShowData from "../../../components/ShowData";
import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import { list, revokePullOutRequest } from "../../../controllers/V1/pullOutRequest/pullOutRequestController";
import { getPage, formatProjectDate } from "../../../controllers/common";
import { usePermissions } from "../../../controllers/PermissionContext";
import { useNavigate } from "react-router-dom";

const { TextArea } = Input;

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`po-tabpanel-${index}`} aria-labelledby={`po-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}><Typography>{children}</Typography></Box>}
    </div>
  );
}
TabPanel.propTypes = { children: PropTypes.node, index: PropTypes.number.isRequired, value: PropTypes.number.isRequired };

function a11yProps(index) {
  return { id: `po-tab-${index}`, "aria-controls": `po-tabpanel-${index}` };
}

const STATUS_TABS = ["", "Pending", "Completed", "Rejected"];

export default function PullOutRequestList() {
  const navigate  = useNavigate();
  const targetRef = useRef(null);
  const PERMISSION = usePermissions("userPullOutRequest");

  const [tabValue, setTabValue]         = useState(0);
  const [statusFilter, setStatusFilter] = useState("");
  const [ALLLISTDATA, setListData]      = useState([]);
  const [TOTALPAGES, setTotalPages]     = useState(1);
  const [currentPage, setCurrentPage]   = useState(1);
  const [LIMIT, setLimit]               = useState(10);
  const [SKIP, setSkip]                 = useState(0);
  const [isLoading, setIsLoading]       = useState(false);
  const [isFilterShow, setFilterShow]   = useState(false);

  const refSearch   = useRef(null);
  const refFromDate = useRef(null);
  const refToDate   = useRef(null);

  const [filter, setFilter] = useState({ search: "", from_date: "", to_date: "" });

  // Revoke modal
  const [revokeModal, setRevokeModal]     = useState({ open: false, item: null });
  const [adminRemarks, setAdminRemarks]   = useState("");
  const [isRevoking, setIsRevoking]       = useState(false);

  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        condition: {
          ...(statusFilter ? { status: statusFilter } : null),
          ...(filter.from_date ? { createdAt: { $gte: filter.from_date, $lte: filter.to_date || new Date() } } : null),
          ...(filter.search ? { contact_no: { $regex: filter.search, $options: "i" } } : null),
        },
        sort: { _id: -1 },
        skip: SKIP || 0,
        limit: LIMIT || 10,
      };
      const res = await list(options);
      if (res.status === true) {
        setListData(res.result || []);
        setTotalPages(getPage(res.count, LIMIT));
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getList();
    document.title = "Orbit Kuwait || Pull-Out Requests";
  }, [currentPage, statusFilter, filter, LIMIT]);

  const handleTabChange = (e, newVal) => {
    setTabValue(newVal);
    setStatusFilter(STATUS_TABS[newVal]);
    setSkip(0);
    setCurrentPage(1);
  };

  const handlePageChange = (e, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleFilterApply = (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    setFilter({ search: form.get("search") || "", from_date: form.get("from_date") || "", to_date: form.get("to_date") || "" });
    setSkip(0);
    setCurrentPage(1);
    setFilterShow(false);
  };

  const handleFilterReset = () => {
    setFilter({ search: "", from_date: "", to_date: "" });
    if (refSearch.current)   refSearch.current.value   = "";
    if (refFromDate.current) refFromDate.current.value = "";
    if (refToDate.current)   refToDate.current.value   = "";
    setSkip(0);
    setCurrentPage(1);
  };

  const handleRevoke = async () => {
    if (!revokeModal.item?._id) return;
    setIsRevoking(true);
    const res = await revokePullOutRequest({ id: revokeModal.item._id, admin_remarks: adminRemarks });
    setIsRevoking(false);
    if (res.status) {
      notification.success({ message: "Pull-out request revoked" });
      setRevokeModal({ open: false, item: null });
      getList();
    } else {
      notification.error({ message: res.message || "Failed to revoke" });
    }
  };

  const statusDot = (status) => {
    const colors = { Pending: "#f5a623", Completed: "rgb(17 174 87)", Rejected: "#ae1151", Approved: "rgb(17 174 87)" };
    return (
      <span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
        <span style={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: colors[status] || "#888", display: "inline-block" }} />
        {status}
      </span>
    );
  };

  const userName = (u) => {
    if (!u) return "—";
    return `${u.users_name || ""} ${u.last_name || ""}`.trim() || u.users_mobile || "—";
  };

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Pull-Out Request List"} />
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs value={tabValue} onChange={handleTabChange} aria-label="pull-out-request-tabs" className="item_tabs_main_container">
                    <Tab label="All"       className="tabs_main_contnet" {...a11yProps(0)} />
                    <Tab label="Pending"   className="tabs_main_contnet" {...a11yProps(1)} />
                    <Tab label="Completed" className="tabs_main_contnet" {...a11yProps(2)} />
                    <Tab label="Rejected"  className="tabs_main_contnet" {...a11yProps(3)} />
                  </Tabs>
                </div>
                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <ShowData setLimit={setLimit} limit={LIMIT} />
                  <div className="inventory_filter_div" onClick={() => setFilterShow(!isFilterShow)}>
                    <FontAwesomeIcon icon={faFilter} />
                    <span className="filter_btn_invontry_rating_review" style={{ cursor: "pointer" }}>&nbsp;Filter</span>
                  </div>
                </div>
              </div>
            </Box>

            <TabPanel value={tabValue} index={tabValue}>
              <div id="content-wrapper" className="d-flex flex-column">
                <div className="card shadow mb-4">
                  <div className="card-body pt-0">
                    <div className="table-responsive">
                      <table className="table table-bordered" width="100%" cellSpacing="0">
                        <thead>
                          <tr>
                            <th>Sl.</th>
                            <th>User</th>
                            <th>Contact No.</th>
                            <th>Deploy Status</th>
                            <th>Account Status</th>
                            <th>BDM Status</th>
                            <th>Status</th>
                            <th>Created</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ALLLISTDATA.length > 0 ? (
                            ALLLISTDATA.map((item, index) => (
                              <tr key={item._id || index}>
                                <td>{SKIP + index + 1}</td>
                                <td>{userName(item.users_id)}</td>
                                <td>{item.contact_no || "—"}</td>
                                <td>{statusDot(item.deployment_status)}</td>
                                <td>{statusDot(item.account_status)}</td>
                                <td>{statusDot(item.bdm_status)}</td>
                                <td>{statusDot(item.status)}</td>
                                <td>{item.createdAt ? moment(formatProjectDate(item.createdAt)).format("DD-MM-YYYY hh:mm A") : "—"}</td>
                                <td style={{ display: "flex", gap: 4 }}>
                                  {(PERMISSION.fullAccess === 'Y' || PERMISSION.list === 'Y') && (
                                    <Button type="link" size="small" onClick={() => navigate("/request/pull-out-view", { state: item })} title="View">
                                      <FontAwesomeIcon icon={faEye} />
                                    </Button>
                                  )}
                                  {(PERMISSION.fullAccess === 'Y' || PERMISSION.revoke === 'Y') && item.status === 'Pending' && (
                                    <Button type="link" danger size="small" onClick={() => { setAdminRemarks(""); setRevokeModal({ open: true, item }); }} title="Revoke">
                                      <FontAwesomeIcon icon={faBan} />
                                    </Button>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : isLoading ? (
                            <SkeltonList row={5} col={9} />
                          ) : (
                            <tr><td colSpan="9" className="img-center">No data found!</td></tr>
                          )}
                        </tbody>
                      </table>
                      <div className="table_pagination_sales_order">
                        <Pagination count={TOTALPAGES} onChange={handlePageChange} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </Box>
        </div>
      </div>

      {/* Filter Drawer */}
      <Drawer title="Filter" placement="right" width={420} onClose={() => setFilterShow(false)} open={isFilterShow}
        extra={<Space><Button onClick={() => setFilterShow(false)}>Cancel</Button><Button type="primary" onClick={handleFilterReset} style={{ backgroundColor: "red", color: "white" }}>Reset</Button></Space>}>
        <form onSubmit={handleFilterApply}>
          <div className="row">
            <div className="form-group col-12 mb-3">
              <label className="all_section_for_label_main_class">Search (Contact No.):</label>
              <input type="text" name="search" className="form-control store_input_field" ref={refSearch} defaultValue={filter.search} placeholder="Search..." />
            </div>
            <div className="form-group col-6 mb-3">
              <label className="all_section_for_label_main_class">From Date:</label>
              <input type="datetime-local" name="from_date" className="form-control store_input_field" ref={refFromDate} defaultValue={filter.from_date} />
            </div>
            <div className="form-group col-6 mb-3">
              <label className="all_section_for_label_main_class">To Date:</label>
              <input type="datetime-local" name="to_date" className="form-control store_input_field" ref={refToDate} defaultValue={filter.to_date} />
            </div>
            <div className="form-group col-12 mt-2">
              <button type="submit" className="form-control btn btn-black" style={{ backgroundColor: "black", color: "white" }}>Apply Filter</button>
            </div>
          </div>
        </form>
      </Drawer>

      {/* Revoke Modal */}
      <Modal title="Revoke Pull-Out Request" open={revokeModal.open}
        onCancel={() => setRevokeModal({ open: false, item: null })}
        footer={[
          <Button key="cancel" onClick={() => setRevokeModal({ open: false, item: null })}>Cancel</Button>,
          <Button key="revoke" type="primary" danger loading={isRevoking} onClick={handleRevoke}>Revoke</Button>,
        ]}>
        <div className="mb-3">
          <label>Admin Remarks:</label>
          <TextArea rows={3} value={adminRemarks} onChange={(e) => setAdminRemarks(e.target.value)} placeholder="Reason for revoke..." />
        </div>
      </Modal>
    </>
  );
}
